__turbopack_context__.v({
  "content": "dropdown-menu-module-scss-module__KkhlXa__content",
  "dropdown": "dropdown-menu-module-scss-module__KkhlXa__dropdown",
  "inner": "dropdown-menu-module-scss-module__KkhlXa__inner",
  "item": "dropdown-menu-module-scss-module__KkhlXa__item",
  "item-highlighted": "dropdown-menu-module-scss-module__KkhlXa__item-highlighted",
  "item-selected": "dropdown-menu-module-scss-module__KkhlXa__item-selected",
  "list": "dropdown-menu-module-scss-module__KkhlXa__list",
  "trigger": "dropdown-menu-module-scss-module__KkhlXa__trigger",
  "trigger--highlighted": "dropdown-menu-module-scss-module__KkhlXa__trigger--highlighted",
  "trigger-open": "dropdown-menu-module-scss-module__KkhlXa__trigger-open",
  "trigger-text": "dropdown-menu-module-scss-module__KkhlXa__trigger-text",
});
